import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

const LogsViewer = ({ logs, containerIndex, height = '300px', scrollableTargetId, isModal = false }) => {
    const [visibleLogs, setVisibleLogs] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const LOGS_PER_PAGE = 50;

    useEffect(() => {
        setVisibleLogs([]);
        setPage(0);
        setHasMore(true);
        const initialLogs = logs?.split('\n').slice(0, LOGS_PER_PAGE) || [];
        setVisibleLogs(initialLogs);
        setPage(1);
    }, [logs, containerIndex]);

    const fetchMoreLogs = () => {
        if (!logs) return;

        // Reset scroll position when container changes
        const scrollableDiv = document.getElementById(scrollableTargetId || `scrollableDiv-${containerIndex}`);
        if (scrollableDiv) {
            scrollableDiv.scrollTop = 0;
        }

        const allLogs = logs.split('\n');
        const startIdx = page * LOGS_PER_PAGE;
        const newLogs = allLogs.slice(startIdx, startIdx + LOGS_PER_PAGE);

        if (newLogs.length < LOGS_PER_PAGE) {
            setHasMore(false);
        }

        setVisibleLogs(prev => [...prev, ...newLogs]);
        setPage(prev => prev + 1);
    };

    const modalStyles = isModal ? {
        height: 'calc(70vh - 76px)', // Account for modal header
        maxHeight: 'calc(70vh - 76px)',
        position: 'relative'
    } : {};

    return (
        <div
            id={scrollableTargetId || `scrollableDiv-${containerIndex}`}
            className="logs-content p-3"
            style={{
                height: isModal ? modalStyles.height : height,
                maxHeight: isModal ? modalStyles.maxHeight : height,
                overflow: 'auto',
                backgroundColor: '#000',
                color: '#fff',
                borderBottomLeftRadius: '7px',
                borderBottomRightRadius: '7px',
                ...(isModal ? { position: 'relative' } : {})
            }}
        >
            {logs ? (
                <InfiniteScroll
                    dataLength={visibleLogs.length}
                    next={fetchMoreLogs}
                    hasMore={hasMore}
                    loader={<div className="text-center text-white">Loading...</div>}
                    scrollableTarget={scrollableTargetId || `scrollableDiv-${containerIndex}`}
                    endMessage={
                        <div className="text-center text-white-50 my-2">
                            Logs are up to date
                        </div>
                    }
                    style={{ overflow: 'hidden' }}
                >
                    {visibleLogs.map((log, index) => (
                        <div
                            key={`${containerIndex}-${index}`}
                            className="log-entry"
                            style={{
                                color: '#fff',
                                fontSize: '0.8rem',
                                fontFamily: 'Consolas, monospace',
                                marginBottom: '4px',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-all'
                            }}
                        >
                            {log}
                        </div>
                    ))}
                </InfiniteScroll>
            ) : (
                    <p className="text-center text-white-50 my-2">
                    No logs available for this container
                </p>
            )}
        </div>
    );
};

export default LogsViewer;